import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Service
import {
    CreateContent,
    GetContentById,
    UpdateContent,
} from "./services/Services.js"
import {
    SavePageSetting,
    SearchPageSetting,
    UpdatePageSetting,
} from "../../services/api/module/PageSetting.js"
import DatePicker from "react-datepicker"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `hero-banner`
const _pageName  = `Hero Banner`
const _routePermission = `hero-banner`

const HeroBannerTemplate = ({ 
    pageView = "create", 
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext)

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? "TH"
    const qMainId = qParams.id
    const navigate = useNavigate()

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        contentName: Yup.string().max(255).required("Please Enter Banner Name"),
        contentBannerDetail: Yup.string().max(255),
        bannerStart: Yup.string().required("Please Enter Banner Start Date"),
        bannerEnd: Yup.string().required("Please Enter Banner End Date"),

        heroBannerDesktop: Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner for Desktop",
            (value) => value && Object.keys(value).length > 0
        ).required("Please Upload Banner for Desktop"),

        heroBannerMobile: Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner for Mobile",
            (value) => value && Object.keys(value).length > 0
        ).required("Please Upload Banner for Mobile"),

        // contentSeoTitle: Yup.string(),
        // contentSeoKeyword: Yup.string().max(1024),
        // contentSeoDescription: Yup.string().max(1024),

        contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
        // contentStatus: Yup.string().max(100).required("Please Enter Display"),
    })

    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] =
        useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        contentName: "",
        contentBannerDetail: "",
        contentLinkout: "",
        bannerStart: "",
        bannerEnd: "",

        heroBannerDesktop: {},
        heroBannerMobile: {},

        // contentSeoTitle: "",
        // contentSeoKeyword: "",
        // contentSeoDescription: "",
        contentUpdateDate: moment().format("YYYY-MM-DD"),
        contentStatus: "active",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
            const payload = {
                id: qMainId,
                contentId: values.contentId ? values.contentId : undefined,
                langId: qLang,
                contentName: values.contentName,
                contentBannerDetail: values.contentBannerDetail,
                contentLinkout: values.contentLinkout,
                bannerStart: values.bannerStart,
                bannerEnd: values.bannerEnd,

                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,

                attachmentData: {
                    
                },

                contentAttachmentData: {
                    heroBannerDesktop: values.heroBannerDesktop,
                    heroBannerMobile: values.heroBannerMobile,
                },
            }
            console.log("🚀 ~ onSave ~ payload:", payload)

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContent(payload)
            }
            else {
                API.fetchCreateContent(payload)
            }
        },
    })

    const preFilInput = (resData = {}) => {
        // console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        validation.setFieldValue("contentId", resData?.contentId ?? "")
        validation.setFieldValue("contentName", resData?.contentName ?? "")
        validation.setFieldValue("contentBannerDetail", resData?.contentBannerDetail ?? "")
        validation.setFieldValue("contentLinkout", resData?.contentLinkout ?? "")
        validation.setFieldValue("bannerStart", resData?.bannerStart ?? "")
        validation.setFieldValue("bannerEnd", resData?.bannerEnd ?? "")

        // console.log('resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"', resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"))

        validation.setFieldValue(
            "heroBannerDesktop",
            resData?.contentHeroBannerDesktop ?? ""
        )
        validation.setFieldValue(
            "heroBannerMobile",
            resData?.contentHeroBannerMobile ?? ""
        )

        validation.setFieldValue(
            "contentUpdateDate",
            resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "contentStatus",
            resData?.contentStatus ?? "active"
        )

        // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
        // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")
    }

    const API = {
        fetchGetContentById: async payload => {
            try {
                const response = await GetContentById({
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload, pageSettingRoute) => {
            try {
                const response = await CreateContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            navigate(`/${_routeLink}/${qLang}`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContent: async (payload, pageSettingRoute) => {
            try {
                const response = await UpdateContent({
                    data: payload,
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)
            API.fetchGetContentById(payload)
            // API.fetchGetContentPageSetting(componentKey)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: "10px",
        border: "1px solid black",
        margin: "5px",
        borderRadius: "8px",
        background: "#f9f9f9",
        transition: "transform 0.2s ease, background-color 0.3s ease",
    }

    const mapValues = (list = []) =>
        list.map(item => {
            const newObj = {
                attachmentId: item.attachmentId,
                sequence: item.sequence,
            }
            return newObj
        })

    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {contentLoading ? (
                        <Spinners setLoading={setContentLoading} />
                    ) : (
                        <Row>
                            <Col className="col-12">
                                <FormikProvider value={validation}>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col className="col-8">
                                                <Row>
                                                    <Col className="col-12">
                                                        <Card>
                                                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                                <i className="bx bx-cube-alt"></i> Information Box
                                                            </h5>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="contentName"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Banner Name
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="contentName"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="contentName"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "contentName",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.contentName}
                                                                                invalid={
                                                                                    validation.touched.contentName &&
                                                                                        validation.errors.contentName
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.contentName &&
                                                                                validation.errors.contentName && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.contentName}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="contentBannerDetail"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Banner Detail
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="contentBannerDetail"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="contentBannerDetail"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "contentBannerDetail",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.contentBannerDetail}
                                                                                invalid={
                                                                                    validation.touched.contentBannerDetail &&
                                                                                        validation.errors.contentBannerDetail
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.contentBannerDetail &&
                                                                                validation.errors.contentBannerDetail && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.contentBannerDetail}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="contentLinkout"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Link Out
                                                                            {/* <span className="t-require">*</span> */}
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="contentLinkout"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="contentLinkout"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "contentLinkout",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.contentLinkout}
                                                                                invalid={
                                                                                    validation.touched.contentLinkout &&
                                                                                        validation.errors.contentLinkout
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.contentLinkout &&
                                                                                validation.errors.contentLinkout && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.contentLinkout}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <Row>
                                                                            <Col className="col-6 mb-3">
                                                                                <label
                                                                                    htmlFor="bannerStart"
                                                                                    className="col-md-12 col-form-label"
                                                                                >
                                                                                    Start Date
                                                                                    <span className="t-require">*</span>
                                                                                </label>
                                                                                <div className="col-md-12">
                                                                                    <DatePicker
                                                                                        dateFormat="yyyy-mm-dd"
                                                                                        id="bannerStart"
                                                                                        className="form-control"
                                                                                        name="bannerStart"
                                                                                        autoComplete="off"
                                                                                        selected={moment().format('YYYY-MM-DD')}
                                                                                        onChange={date => {
                                                                                            validation.setFieldValue(
                                                                                                "bannerStart",
                                                                                                moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
                                                                                            )
                                                                                        }}
                                                                                        onBlur={validation.handleBlur}
                                                                                        value={validation.values.bannerStart}
                                                                                        invalid={
                                                                                            validation.touched.bannerStart &&
                                                                                                validation.errors.bannerStart
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        disabled={pageView === "view"}
                                                                                    />
                                                                                    {validation.touched.bannerStart &&
                                                                                        validation.errors.bannerStart && (
                                                                                            <FormFeedback type="invalid">
                                                                                                {validation.errors.bannerStart}
                                                                                            </FormFeedback>
                                                                                        )}
                                                                                </div>
                                                                                <hr />
                                                                            </Col>
                                                                            <Col className="col-6 mb-3">
                                                                                <label
                                                                                    htmlFor="bannerEnd"
                                                                                    className="col-md-12 col-form-label"
                                                                                >
                                                                                    End Date
                                                                                    <span className="t-require">*</span>
                                                                                </label>
                                                                                <div className="col-md-12">
                                                                                    <DatePicker
                                                                                        dateFormat="yyyy-mm-dd"
                                                                                        id="bannerEnd"
                                                                                        className="form-control"
                                                                                        name="bannerEnd"
                                                                                        autoComplete="off"
                                                                                        selected={moment().format('YYYY-MM-DD')}
                                                                                        onChange={date => {
                                                                                            validation.setFieldValue(
                                                                                                "bannerEnd",
                                                                                                moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
                                                                                            )
                                                                                        }}
                                                                                        onBlur={validation.handleBlur}
                                                                                        value={validation.values.bannerEnd}
                                                                                        invalid={
                                                                                            validation.touched.bannerEnd &&
                                                                                                validation.errors.bannerEnd
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        disabled={pageView === "view"}
                                                                                    />
                                                                                    {validation.touched.bannerEnd &&
                                                                                        validation.errors.bannerEnd && (
                                                                                            <FormFeedback type="invalid">
                                                                                                {validation.errors.bannerEnd}
                                                                                            </FormFeedback>
                                                                                        )}
                                                                                </div>
                                                                                <hr />
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <Row>
                                                                            <Col className="col-12 mb-3">
                                                                                {/* {JSON.stringify(validation.values.bannerDesktop)} */}
                                                                                <div className="col-md-12">
                                                                                    <PopupAttachment
                                                                                        typeDetail="single"
                                                                                        typeUpload="ImageVideoMap"
                                                                                        upload="ImageVideo"
                                                                                        prefixName="hero-banner-desktop"
                                                                                        label="Banner Desktop"
                                                                                        required={true}
                                                                                        description="description"
                                                                                        widthSize={2160}
                                                                                        heightSize={990}
                                                                                        value={validation.values.heroBannerDesktop}
                                                                                        onChange={(value = {}, index) => {
                                                                                            console.log("🚀 onChange ~ value:", value)
                                                                                            console.log("🚀 onChange ~ index:", index)
                                                                                            validation.setFieldValue('heroBannerDesktop', value)
                                                                                        }}
                                                                                        onRemove={(index) => {
                                                                                            console.log("🚀 onChange ~ index:", index)
                                                                                            validation.setFieldValue('heroBannerDesktop', {})
                                                                                        }}
                                                                                    />
                                                                                    {validation.touched.heroBannerDesktop && validation.errors.heroBannerDesktop && (
                                                                                        <div type="invalid" className="invalid-feedback d-block">
                                                                                            {validation.errors.heroBannerDesktop}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <hr />
                                                                            </Col>
                                                                            <Col className="col-12 mb-3">
                                                                                {/* {JSON.stringify(validation.values.bannerMobile)} */}
                                                                                <div className="col-md-12">
                                                                                    <PopupAttachment
                                                                                        typeDetail="single"
                                                                                        typeUpload="ImageVideoMap"
                                                                                        upload="ImageVideo"
                                                                                        prefixName="hero-banner-mobile"
                                                                                        label="Banner Mobile"
                                                                                        required={true}
                                                                                        description="description"
                                                                                        widthSize={540}
                                                                                        heightSize={780}
                                                                                        value={validation.values.heroBannerMobile}
                                                                                        onChange={(value = {}, index) => {
                                                                                            console.log("🚀 onChange ~ value:", value)
                                                                                            console.log("🚀 onChange ~ index:", index)
                                                                                            validation.setFieldValue('heroBannerMobile', value)
                                                                                        }}
                                                                                        onRemove={(index) => {
                                                                                            console.log("🚀 onChange ~ index:", index)
                                                                                            validation.setFieldValue('heroBannerMobile', {})
                                                                                        }}
                                                                                    />
                                                                                    {validation.touched.heroBannerMobile && validation.errors.heroBannerMobile && (
                                                                                        <div type="invalid" className="invalid-feedback d-block">
                                                                                            {validation.errors.heroBannerMobile}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <hr />
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col className="col-4">
                                                <Card
                                                    outline
                                                    color="primary"
                                                    className="border sticky-element"
                                                >
                                                    <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                        <i className="bx bx-check"></i> Tools Box
                                                    </h5>
                                                    <CardBody>
                                                        <Row>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Switch Language
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputLang
                                                                        widthfull
                                                                        pageView={pageView}
                                                                        forceRoute={false}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Written at
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputGroup>
                                                                        <Flatpickr
                                                                            className="form-control d-block"
                                                                            options={{
                                                                                dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                            }}
                                                                            value={
                                                                                validation.values.contentUpdateDate
                                                                                    ? moment(
                                                                                        validation.values
                                                                                            .contentUpdateDate,
                                                                                        "YYYY-MM-DD"
                                                                                    ).toDate()
                                                                                    : null
                                                                            }
                                                                            disabled={true}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                disabled
                                                                            >
                                                                                <i
                                                                                    className="fa fa-calendar"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </InputGroup>
                                                                    {validation.touched.contentUpdateDate &&
                                                                        validation.errors.contentUpdateDate && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentUpdateDate}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Display
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Select
                                                                        placeholder="Select Status"
                                                                        value={fn_helper.FNFORM.getObjectValue(
                                                                            STATUS_OPTION,
                                                                            `${validation.values.contentStatus}`
                                                                        )}
                                                                        onChange={value =>
                                                                            validation.setFieldValue(
                                                                                "contentStatus",
                                                                                value.id
                                                                            )
                                                                        }
                                                                        getOptionValue={option => option.id}
                                                                        getOptionLabel={option => option.name}
                                                                        options={STATUS_OPTION}
                                                                        className={`select2-selection ${validation.touched.contentStatus &&
                                                                                validation.errors.contentStatus
                                                                                ? "input-err"
                                                                                : ""
                                                                            }`}
                                                                        isDisabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentStatus &&
                                                                        validation.errors.contentStatus && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentStatus}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                    <CardFooter>
                                                        <Row>
                                                            <Col className="text-start">
                                                                <Button
                                                                    color="danger"
                                                                    className="btn btn-danger"
                                                                    onClick={() =>
                                                                    navigate(`/${_routeLink}/${qLang}`)
                                                                    }
                                                                >
                                                                    Back
                                                                </Button>
                                                            </Col>
                                                            <Col className="text-end">
                                                                {pageView !== "view" && (
                                                                    <Button
                                                                        type="submit"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Save{" "}
                                                                        {waitSendData ? (
                                                                            <Spinner size="sm" color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormikProvider>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

// HeroBannerTemplate.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(HeroBannerTemplate)
